module.exports = __webpack_public_path__ + "static/media/fp-icon-primary.dbd1a11d.svg";